module.exports = __webpack_public_path__ + "static/media/republicBank.4c4d0ebe.svg";